export default __webpack_public_path__ + "static/media/animal-track-transparent-2.e16fa77f.png";